var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClipboardBlank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V3.5H19C19.5523 3.5 20 3.94772 20 4.5V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V4.5C4 3.94772 4.44772 3.5 5 3.5H7V3ZM9 5V4H15V5H9ZM7 5.5H6V20H18V5.5H17V6C17 6.55228 16.5523 7 16 7H8C7.44772 7 7 6.55228 7 6V5.5Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipboardBlank);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDNDNyAyLjQ0NzcyIDcuNDQ3NzIgMiA4IDJIMTZDMTYuNTUyMyAyIDE3IDIuNDQ3NzIgMTcgM1YzLjVIMTlDMTkuNTUyMyAzLjUgMjAgMy45NDc3MiAyMCA0LjVWMjFDMjAgMjEuNTUyMyAxOS41NTIzIDIyIDE5IDIySDVDNC40NDc3MiAyMiA0IDIxLjU1MjMgNCAyMVY0LjVDNCAzLjk0NzcyIDQuNDQ3NzIgMy41IDUgMy41SDdWM1pNOSA1VjRIMTVWNUg5Wk03IDUuNUg2VjIwSDE4VjUuNUgxN1Y2QzE3IDYuNTUyMjggMTYuNTUyMyA3IDE2IDdIOEM3LjQ0NzcyIDcgNyA2LjU1MjI4IDcgNlY1LjVaIiBmaWxsPSIjMDQwNDA1Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };